import { Box } from '@nimbus-ds/components';
import { ONBOARDING_PROMOTE } from 'App/featuresFlags';
import { useResponsive } from 'commons/components';
import { useGetTags } from 'domains/Auth/hooks';
import { STYLE_STATS_DAILY_TAB_CONTENT } from './StatsDailyTabContent';
import StatsDailyValueCard from './StatsDailyValueCard';

function Skeleton() {
  const { isMobile } = useResponsive();
  const tags = useGetTags();
  const hasOnboardingPromoteTag = tags.includes(ONBOARDING_PROMOTE);

  return (
    <Box
      {...STYLE_STATS_DAILY_TAB_CONTENT}
      gridTemplateColumns={
        !isMobile && hasOnboardingPromoteTag
          ? 'repeat(4, 1fr)'
          : 'repeat(2, 1fr)'
      }
    >
      <StatsDailyValueCard.Skeleton />
      <StatsDailyValueCard.Skeleton />
      <StatsDailyValueCard.Skeleton />
      <StatsDailyValueCard.Skeleton />
    </Box>
  );
}

export default Skeleton;
